import {SavedQueriesContext} from "../providers/context";
import {useContext} from "react";

export default function useSavedQueries() {
    return useContext(SavedQueriesContext)
}